import { Multifree } from '@yes.technology/react-toolkit'

import { StatusClass } from 'types/shared'

export type ActivityMultipleAnswersProps = {
  label?: string
  value: string
  onChange: (value: string) => void
  statusClass?: StatusClass
  readOnly?: boolean
  disabled?: boolean
  helpText?: string
  explanationText?: string
  required?: boolean
}

function parseItems(value: string): string[] {
  try {
    const parsed = JSON.parse(value)
    if (Array.isArray(parsed)) return parsed
  } catch {
    // ignore
  }
  return []
}

function ActivityMultipleAnswers({
  label,
  value,
  onChange,
  statusClass,
  readOnly,
  disabled,
  helpText,
  required,
  explanationText
}: ActivityMultipleAnswersProps) {
  const initialItems = parseItems(value)

  const handleItemsChange = (items: string[]) => {
    onChange(JSON.stringify(items))
  }

  return (
    <Multifree
      label={label}
      value=''
      placeholder={helpText || explanationText}
      statusClass={statusClass}
      informational={readOnly}
      disabled={disabled}
      initialItems={initialItems}
      required={required}
      onChange={handleItemsChange}
    />
  )
}

export default ActivityMultipleAnswers
